import { User } from '@yarmill/types';

export function getUserName(a: Partial<User>): string {
  return `${a.LastName} ${a.FirstName}`;
}
